import { z } from 'zod';

export enum FaqCategoryEnum {
  LUGGAGE_INSURANCE = 'luggageInsurance',
  FLIGHT_INSURANCE = 'flightInsurance',
  MEDICAL_ASSISTANCE = 'medicalAssistance',
  INSURANCE_MANAGEMENT = 'insuranceManagement',
  DATA = 'data',
  CONTACT_US = 'contactUs',
}

export const faqSearchSchema = z.strictObject({
  category: z.nativeEnum(FaqCategoryEnum).optional().catch(undefined),
});

export type FaqSearch = z.output<typeof faqSearchSchema>;
